// App.tsx betöltési-sorrend döntése — kiemelve, hogy tesztelhető legyen a
// user-váltás (logout/fiókváltás) körüli race condition nélkül.
//
// A `user`-t itt csak igazságértékként vizsgáljuk (bejelentkezett-e), a
// tényleges Firebase User objektumot a hívó adja át.
export function shouldShowAuthLoadingSpinner(
  authLoading: boolean,
  isLoggedIn: boolean,
  onboardingDone: boolean | null
): boolean {
  return authLoading || (isLoggedIn && onboardingDone === null);
}
